export default "__VITE_ASSET__f237e69e__"